import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../../globalProps';
import './Radio.css';

interface Props<T extends string> extends GlobalProps {
  checked: boolean;
  label: string;
  name: string;
  value: T;
  disabled?: boolean;
  onChange(value: T): void;
}

export function Radio<T extends string>({ checked, label, name, value, disabled, onChange }: Props<T>): JSX.Element {
  return (
    <label className={classnames('radio', { 'radio--checked': checked, 'radio--disabled': disabled })}>
      <div className="radio__input-wrapper">
        <input
          className="radio__input"
          type="radio"
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value as T)}
          checked={checked}
          disabled={disabled}
        />
      </div>
      <span className="radio__label">{label}</span>
    </label>
  );
}
